export interface ReferAndEarnPopupProps {
    open: boolean;
    onClose: () => void;
}

export const mapStateToProps = (state) => ({
    // No state needed for this popup
});

export const mapDispatchToProps = {
    // No actions needed for this popup
};
